const EstimationScenarioTypes = {
  LOW: "low",
  EXPECTED: "expected",
  POTENTIAL: "potential"
};

EstimationScenarioTypes.ALL = Object.values(EstimationScenarioTypes);

export default EstimationScenarioTypes;
